import links from "@/links/links";
import qs from "qs";

export default {
  actions: {
    GET(id) {
      return this.get(links.MEETING_GET(id));
    },
    GET_BY_BUILDING_WITH_BO_DOCUMENTS(buildingId, queryParams) {
      // NOTE: prepare query params
      let processedQueryParams = {};
      // filters
      queryParams.filter.forEach(filter => {
        processedQueryParams[filter.column] = filter.value;
      });
      // order
      processedQueryParams[`order[${queryParams.sort.by}]`] = queryParams.sort.dir.toLowerCase();
      // page
      processedQueryParams.page = queryParams.page;
      processedQueryParams.itemsPerPage = queryParams.itemsPerPage;

      return this.get(links.MEETING_GET_BY_BUILDING_WITH_BO_DOCUMENTS(buildingId), {
        params: processedQueryParams,
        paramsSerializer: params => {
          return qs.stringify(params);
        },
        dataKey: "hydra:member",
      });
    },
    GET_DETAILS_FOR_CORRESPONDENCE_VOTING(meetingId) {
      return this.get(links.MEETING_DETAILS_FOR_CORRESPONDENCE_VOTING(meetingId));
    },
  },
};
